import ChoiceEcho from '../components/choice/choice_echo.vue';

import DetermineEcho from '../components/determine/determine_echo.vue';

import FillingBlanksEcho from '../components/fillingBlanks/fillingBlanks_echo.vue';

import MatrimFillEcho from '../components/fillingBlanks/matrim_fill_echo.vue';

import SumEcho from '../components/sum/sum_echo.vue'

import ImgDragEcho from '../components/imgDrag/imgDrag_echo.vue'

import TextDragEcho from '../components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from '../components/textDrag/textDrag_echo_2.vue'

import LigatureEcho from '../components/ligature/ligature_echo.vue'

import HotspotEcho from '../components/hotspot/hotspot_echo.vue'

import LeaveDialog from '../components/dialog/leaveDialog.vue'

import TipsDialog from '../components/dialog/tips.vue'
import ConfirmSubmit from '../components/dialog/confirmSubmit.vue'
import AnsweringDialog from '../components/dialog/answeringDialog.vue'
import IssuesDialog from '../components/dialog/issuesDialog.vue'
import ShowBigPhoto from '../components/dialog/showBigPhoto.vue'
import DialogPreview from '../dialog/index.vue'

import QuizDialog from '../components/dialog/quizDialog.vue'
import Complete from '../complete.vue'

export default {

  ChoiceEcho,

  DetermineEcho,

  FillingBlanksEcho,

  MatrimFillEcho,

  SumEcho,

  ImgDragEcho,

  TextDragEcho,

  TextDragEcho2,

  LigatureEcho,

  HotspotEcho,

  LeaveDialog,
  TipsDialog,
  ConfirmSubmit,
  AnsweringDialog,
  IssuesDialog,
  ShowBigPhoto,
  DialogPreview,
  QuizDialog,
  Complete
}